import { Container, Divider } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { JumpNav, Tab, useJumpNavConfig } from '../../../Tabs';
import { StickyStackItem } from '../../StickyStack';

export type ProviderLayoutJumpNavProps = {
  tabs: {
    label: string;
    sectionId: string;
  }[];
  initialNavValue: string;
};

export const ProviderLayoutJumpNav: React.VFC<ProviderLayoutJumpNavProps> = props => {
  const { classes } = useProviderLayoutJumpNavStyles();
  const { navValue } = useJumpNavConfig({ initialNavValue: props.initialNavValue, sectionIds: props.tabs.map(tab => tab.sectionId) });

  return (
    <StickyStackItem order={1} placement="top">
      <div className={classes.tabsWrapper}>
        <Container className={classes.tabsContainer}>
          <JumpNav
            className={classes.tabs}
            value={navValue}
            indicatorColor="secondary"
            textColor="secondary"
            variant="scrollable"
          >
            {props.tabs.map(({ label, sectionId }) => (
              <Tab
                jump
                label={label}
                value={sectionId}
                headerOffset={80}
                key={sectionId}
                className={classes.tab}
              />
            ))}
          </JumpNav>
        </Container>
        <Divider />
      </div>
    </StickyStackItem>
  );
};

const useProviderLayoutJumpNavStyles = makeStyles({ name: 'ProviderLayoutJumpNav' })(theme => ({
  tabsWrapper: {
    background: theme.palette.common.white,
    zIndex: theme.zIndex.appBar + 1,
  },
  tabsContainer: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  tabs: {
    '& *': {
      borderBottom: 'none !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
    },
  },
  tab: {
    flex: '1 0 auto',
    minWidth: 'unset',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    whiteSpace: 'nowrap',

    [theme.breakpoints.up('md')]: {
      flex: 'unset'
    }
  }
}));
